import { useTranslation } from '#/features/localization/utils';

import * as Alert from '#/components/common/Alert';
import { Paragraph } from '#/components/shared/Modal';

import { DISCORD_URL } from '#/routes-external';

import LegalDisclaimer from './LegalDisclaimer';
import PrimaryButton from './PrimaryButton';
import * as Modal from './Modal';

interface Props {
  readonly isOpen: boolean;
  readonly close: () => void;
}

export default function NoAccessAllowedModal(props: Props) {
  const { close, isOpen } = props;
  const { t } = useTranslation();

  return (
    <Modal.Root isOpen={isOpen} onDismiss={close}>
      <Modal.Header>
        <Modal.Title>No Access Allowed</Modal.Title>
      </Modal.Header>

      <Paragraph>
        <LegalDisclaimer />
      </Paragraph>

      <Alert.Error>
        You don&apos;t have access to the platform. Please join our discord to
        get access.
      </Alert.Error>

      <PrimaryButton as="a" target="_blank" rel="noopener" href={DISCORD_URL}>
        {t('Join Discord')}
      </PrimaryButton>
    </Modal.Root>
  );
}
